import { render, staticRenderFns } from "./FriendCard.vue?vue&type=template&id=9d59e40a"
import script from "./FriendCard.vue?vue&type=script&lang=js"
export * from "./FriendCard.vue?vue&type=script&lang=js"
import style0 from "./FriendCard.vue?vue&type=style&index=0&id=9d59e40a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports